import _get from 'lodash/get';
import _has from 'lodash/has';

export const shouldDisplayQuestion = (mappings, field, clientShortName) => {
  const config = _get(mappings, ['config', field], {});
  const isClientExclusive = _has(config, 'clients');
  if (isClientExclusive)
    return _get(config, 'clients', []).includes(clientShortName);

  return !_get(config, 'excludeClients', []).includes(clientShortName);
};
